import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ThemeProvider from "./theme/theme-provider";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { GlobalProvider } from "./context/GlobalProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <GlobalProvider>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </GlobalProvider>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);
